module.exports = __webpack_public_path__ + "static/media/Portrait-10018.7aeb7ba0.jpg";